(() => {
  const videoSelector = '.js-mmg-autoplay-video';
  const thumbnailVideoSelector = '.js-mmg-thumbnail-video';
  const visibleClass = 'mmg-video-is-visible';
  const readyClass = 'mmg-video-ready';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  let observer = null;

  const isMobile = () => mobileQuery.matches;

  const pauseVideo = (video) => {
    if (!video) return;

    video.classList.remove(visibleClass);
    video.pause();
  };

  const prepareVideo = (video) => {
    if (!video || video.dataset.mmgPrepared === 'true') return;

    video.dataset.mmgPrepared = 'true';

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;

    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.removeAttribute('controls');

    video.addEventListener('playing', () => {
      video.classList.add(readyClass);
    });

    video.addEventListener('waiting', () => {
      video.classList.remove(readyClass);
    });

    video.addEventListener('pause', () => {
      if (!video.classList.contains(visibleClass)) {
        video.classList.remove(readyClass);
      }
    });

    video.addEventListener('ended', () => {
      video.currentTime = 0;

      if (video.classList.contains(visibleClass)) {
        playVideo(video);
      }
    });
  };

  const shouldSkipVideo = (video) => {
    return isMobile() && video.classList.contains('js-mmg-thumbnail-video');
  };

  const playVideo = (video) => {
    if (!video || shouldSkipVideo(video)) return;

    prepareVideo(video);

    video.classList.add(visibleClass);

    if (video.ended) {
      video.currentTime = 0;
    }

    const promise = video.play();

    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {});
    }
  };

  const pauseAllVideos = () => {
    document.querySelectorAll(videoSelector).forEach(pauseVideo);
  };

  const disableMobileThumbnailVideos = () => {
    if (!isMobile()) return;

    document.querySelectorAll(thumbnailVideoSelector).forEach((video) => {
      pauseVideo(video);
      video.removeAttribute('autoplay');
      video.setAttribute('preload', 'none');

      video.querySelectorAll('source').forEach((source) => {
        source.dataset.src = source.getAttribute('src') || '';
        source.removeAttribute('src');
      });

      video.load();
    });
  };

  const restoreDesktopThumbnailVideos = () => {
    if (isMobile()) return;

    document.querySelectorAll(thumbnailVideoSelector).forEach((video) => {
      video.querySelectorAll('source').forEach((source) => {
        if (source.dataset.src && !source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
        }
      });
    });
  };

  const isUsableSlide = (video) => {
    const slide = video.closest('.swiper-slide');

    if (!slide) return true;
    if (slide.classList.contains('swiper-slide-duplicate')) return false;

    return true;
  };

  const observeVideos = () => {
    if (observer) {
      observer.disconnect();
    }

    disableMobileThumbnailVideos();
    restoreDesktopThumbnailVideos();

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (!isUsableSlide(video) || shouldSkipVideo(video) || document.hidden) {
            pauseVideo(video);
            return;
          }

          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      {
        threshold: [0, 0.55],
        rootMargin: '0px'
      }
    );

    document.querySelectorAll(videoSelector).forEach((video) => {
      if (shouldSkipVideo(video)) return;

      prepareVideo(video);
      observer.observe(video);
    });
  };

  const init = () => {
    observeVideos();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', () => {
      pauseAllVideos();
      init();
    });
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(() => {
      pauseAllVideos();
      init();
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseAllVideos();
    } else {
      init();
    }
  });
})();